import * as d3 from 'd3';

import draw from './draw';

import { Data } from "../../../types"; 

const width = 1200;
const height = 800;

/**
 * Starts the simulation of forces between nodes in the workspace map.
 * Also calls the draw function to draw our map.
 * 
 * TODO: remove use of any (create typings for renderChartFn in hooks/useD3.ts)
 * 
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 * @author Teemu Salonen <teemu.salonen@kvanttori.fi>
 */

const forceSimulation = (svg: any, data: Data, updateNode: (value: string) => void) => {
  const links = data.links.map(e => Object.create(e));
  const nodes = data.nodes.map(n => Object.create(n));

  const simulation = d3.forceSimulation(nodes)
    .force('collision', d3.forceCollide().radius(15))
    .force('charge', d3.forceManyBody().strength(-80))
    .force('link', d3.forceLink(links).id((d: any) => d.id))
    .force("center", d3.forceCenter(width / 2, height / 2))
    .force("x", d3.forceX())
    .force("y", d3.forceY());
    
    
  const graph = svg.append("g");

  draw(simulation, nodes, links, graph, svg, updateNode);

  return svg.node();
};

export default forceSimulation;
